import React from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { bindActionCreators } from 'redux';

import SMS_POPUP_NAME from 'constants/smsPopUpName.const';
import { withTranslation } from 'providers/GILT.provider';
import selectEffectiveUserRole from 'selectors/selectEffectiveUserRole';
import { isEffectiveReceptionist } from 'selectors/user';
import fromAnyToString from 'utils/converters/fromAnyToString';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import {
  getUniqClients,
  purchaseSmsBundle,
  sendMarketingSMS,
  setMessageSent,
  setSmsMessage,
} from 'clientCommunications/actions';
import NotSmsCreditDialog from 'clientCommunications/components/Clients/NotSmsCreditDialog';
import PopupWith2Buttons from 'clientCommunications/components/Clients/PopupWith2Buttons';
import PurchaseSmsCreditDialog from 'clientCommunications/components/Clients/PurchaseSmsCreditDialog';
import SmsComposeAndSend from 'clientCommunications/components/Clients/SmsComposeAndSend';
import SmsSentDialog from 'clientCommunications/components/Clients/SmsSentDialog';
import { getSalonOnlineSettings } from 'settings/online-booking/actions';
import { trackEvent } from 'tracking/actions';

class SmsButtonNew extends React.Component {
  static defaultProps = {
    setFinalAgreeToSend: alwaysNoop, // eslint-disable-line react/default-props-match-prop-types
    showParentSmsPopup: alwaysNoop,
    procedure: null,
    clientId: 0,
    noButton: false, // eslint-disable-line react/default-props-match-prop-types
    duplicated: 0,
    optoutNote: '',
    bookingID: 0,
    clientName: '',
    isOpen: false,
    smsComposeModalOpen: false,
    moveNotify: false,
    cancelled: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      beforeSendPopupOpen: false,
      billingPopupOpen: false,
      finalAgreeToSend: false,
      exitPopupOpen: false,
      smsComposeModalOpen: props.smsComposeModalOpen ? props.smsComposeModalOpen : false,
      smsSentModalOpen: false,
      isOpen: false,
      unique_recipients_count: 0,
      initialNotifyMessageSet: false,
      salonNotSmsCreditPopup: false,
      purchaseModal: false,
      currentStylist: this.props?.procedure?.stylist?.user_name,
    };
  }

  componentDidMount() {
    this.showPopup(SMS_POPUP_NAME.smsCompose);
    this.props.getSalonOnlineSettings(this.props.salonId);
    if (this.props.procedure && this.props.moveNotify && !this.state.initialNotifyMessageSet) {
      const clientName = this.props.procedure.appointment.client.user_name;
      const { salonName } = this.props;
      const appointmentDate = moment(this.props.procedure.start_time).format('ddd, Do MMM');
      const appointmentTime = moment(this.props.procedure.start_time).format('h:mm a');
      this.setState({ initialNotifyMessageSet: true });
      const stylistId = this.props.procedureDragFrom;

      let stylist;
      if (this.props.displayStylists.length > 1) {
        // eslint-disable-next-line prefer-destructuring
        stylist = this.props.stylists.filter((s) => s.id === stylistId)[0];
      }
      if (this.props.displayStylists.length === 1 || (stylist && !stylist.serves_as_waitlist)) {
        this.setSmsMessage(
          this.props.t('scheduler.smsButton.movedMessage', {
            clientName,
            salonName,
            appointmentDate,
            appointmentTime,
          }),
          1,
        );
      } else {
        this.setSmsMessage(
          this.props.t('scheduler.smsButton.confirmedMessage', {
            clientName,
            salonName,
            appointmentDate,
            appointmentTime,
            phone: this.props.phone,
          }),
          1,
        );
      }
    }
    if (this.props.procedure && this.props.cancelled && !this.state.initialNotifyMessageSet) {
      const clientName = this.props.procedure.appointment.client.user_name;
      const { salonName } = this.props;
      const appointmentDate = moment(this.props.procedure.start_time).format('ddd, Do MMM');
      this.setState({ initialNotifyMessageSet: true });
      if (this.props.online_booking) {
        this.setSmsMessage(
          this.props.t('scheduler.smsButton.cancelledLinkMessage', {
            clientName,
            salonName,
            appointmentDate,
            ncobTinyUrl: this.props.ncobTinyUrl,
          }),
          1,
        );
      } else {
        this.setSmsMessage(
          this.props.t('scheduler.smsButton.cancelledPhoneMessage', {
            clientName,
            salonName,
            appointmentDate,
            phone: this.props.phone,
          }),
          1,
        );
      }
    }
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.messageSent) {
      this.setState({ smsSentModalOpen: true });
      this.props.setMessageSent(null);
    }
    if (nextProps.unique_recipients_count) {
      this.setState({ unique_recipients_count: nextProps.unique_recipients_count });
    }

    const { smsComposeModalOpen: nextSmsComposeModalOpen } = nextProps;
    const { smsComposeModalOpen: prevSmsComposeModalOpen } = this.props;

    // avoid unnecessary state change and re-render
    if (nextSmsComposeModalOpen !== prevSmsComposeModalOpen) {
      this.setState({ smsComposeModalOpen: nextSmsComposeModalOpen });
      if (nextSmsComposeModalOpen) {
        this.handleOpen(true);
      } else {
        this.handleOpen(false);
      }
    }

    if (nextProps.procedure && nextProps.moveNotify && !this.state.initialNotifyMessageSet) {
      const clientName = nextProps.procedure.appointment.client.user_name;
      const { salonName } = nextProps;
      const appointmentDate = moment(nextProps.procedure.start_time).format('ddd, Do MMM');
      const appointmentTime = moment(nextProps.procedure.start_time).format('h:mm a');
      this.setState({ initialNotifyMessageSet: true });
      const stylistId = this.props.procedureDragFrom;
      const isSingleStylist = this.props.displayStylists.length === 1;
      let stylist;
      if (!isSingleStylist) {
        // eslint-disable-next-line prefer-destructuring
        stylist = this.props.stylists.filter((s) => s.id === stylistId)[0];
      }
      if (isSingleStylist || (stylist && !stylist.serves_as_waitlist)) {
        this.setSmsMessage(
          this.props.t('scheduler.smsButton.confirmedStylistMessage', {
            clientName,
            salonName,
            appointmentDate,
            appointmentTime,
            currentStylist: this.state.currentStylist,
          }),
          1,
        );
      } else {
        this.setSmsMessage(
          this.props.t('scheduler.smsButton.replyMessage', {
            clientName,
            salonName,
            appointmentDate,
            appointmentTime,
            phone: this.props.phone,
          }),
          1,
        );
      }
    }
  }

  componentWillUnmount() {
    this.setState({ initialNotifyMessageSet: false });
  }

  setFinalAgreeToSend = () => void this.setState({ finalAgreeToSend: !this.state.finalAgreeToSend });
  setSmsMessage = (text, numOfMessages) => void this.props.setSmsMessage(text, numOfMessages);

  getPopupConentBeforeSend = () => {
    const { t } = this.props;
    if (this.props.sending_allowed) {
      if (this.props.duplicated && this.props.duplicated > 0) {
        return (
          <div>
            {t('scheduler.smsButton.usage', {
              numOfTexts: this.props.expected_count,
              texts: this.props.expected_count > 1 ? t('scheduler.smsButton.texts') : t('scheduler.smsButton.text'),
              numOfClients: this.state.unique_recipients_count,
              clients:
                this.state.unique_recipients_count > 1
                  ? t('scheduler.smsButton.clients')
                  : t('scheduler.smsButton.client'),
            })}
          </div>
        );
      }
      // if (this.state.unique_recipients_count === 0 || this.props.clientHasNoPhone) {
      if (this.state.unique_recipients_count === 0) {
        return (
          <div>
            {t('scheduler.smsButton.textError')}
            {/* as they do not have a valid UK mobile number in their
            profile */}
          </div>
        );
      } else {
        return (
          <div>
            {t('scheduler.smsButton.usage', {
              numOfTexts: this.props.expected_count,
              texts: this.props.expected_count > 1 ? t('scheduler.smsButton.texts') : t('scheduler.smsButton.text'),
              numOfClients: this.state.unique_recipients_count,
              clients:
                this.state.unique_recipients_count > 1
                  ? t('scheduler.smsButton.clients')
                  : t('scheduler.smsButton.client'),
            })}
          </div>
        );
      }
    }

    return (
      <div>
        {this.props.clientHasNoPhone ? (
          <>
            {/* Sorry you can&apos;t send Text to this client as they do not have a valid UK mobile number in their profile */}
            {t('scheduler.smsButton.textError')}
          </>
        ) : (
          <>
            {t('scheduler.smsButton.creditsError', {
              count: this.props.expected_count,
              credits: this.props.sms_credits_available,
            })}
            <div style={{ fontSize: '0.7em', marginTop: '20px' }}>{t('scheduler.smsButton.purchaseMore')}</div>
          </>
        )}
      </div>
    );
  };

  uniqNoteConentBeforeSend = () => {
    if (this.props.sending_allowed) {
      if (this.props.duplicated && this.props.duplicated > 0) {
        return <div>{this.props.t('scheduler.smsButton.excludeDupes')} 🙌</div>;
      }
      return '';
    }
    return '';
  };

  sendSms = () => {
    const {
      bucketType: clientBucketType,
      procedure,
      salonId,
      bookingID,
      messageSent,
      sendMarketingSMS,
      numOfMessages,
      smsMessage,
      clientId,
    } = this.props;

    const bookingId = bookingID;
    const appointment = procedure?.appointment;
    const client = appointment?.client;

    const recipients = client ? [client?.id] : clientId;
    const appointmentId = bookingId ? bookingId : appointment?.id ? appointment?.id : void 1;

    const messageBucketType =
      clientBucketType === 'list'
        ? 'all'
        : clientBucketType === 'first'
          ? 'first_time'
          : clientBucketType === 'cancelations'
            ? 'canceled_last_month'
            : clientBucketType;

    if (!messageSent) {
      sendMarketingSMS(
        {
          recipients,
          text: smsMessage,
          numOfMessages,
          bucket: messageBucketType,
          appointment: appointmentId,
          title: '',
        },
        fromAnyToString(salonId),
      );
    }
  };

  gotoBilling = () => {
    const oldpath = this.props.history.location.pathname;
    let newPath;
    if (oldpath.indexOf('day') > 0) {
      newPath = `${oldpath.split('day/')[0]}settings/billing`;
    } else if (oldpath.indexOf('communications') > 0) {
      newPath = `${oldpath.split('communications/')[0]}settings/billing`;
    } else {
      newPath = `${oldpath.split('week/')[0]}settings/billing`;
    }
    this.props.history.push({ pathname: newPath });
  };

  gotoOnlineBooking = () => {
    const oldpath = this.props.history.location.pathname;
    let newPath;
    if (oldpath.indexOf('day') > 0) {
      newPath = `${oldpath.split('day/')[0]}onlinebooking`;
    } else if (oldpath.indexOf('communications') > 0) {
      newPath = `${oldpath.split('communications/')[0]}onlinebooking`;
    } else {
      newPath = `${oldpath.split('week/')[0]}onlinebooking`;
    }
    this.props.history.push({ pathname: newPath });
  };

  handleOpen = (tf, fromWhere) => {
    // we don't need to close compose after purchase
    if (!fromWhere) {
      this.setState({ isOpen: tf, smsComposeModalOpen: tf });
    }
    if ((fromWhere === 'success' || fromWhere === 'exit-totally') && this.props.showParentSmsPopup) {
      this.props.showParentSmsPopup(false);
      this.props.setSmsMessage('', 0);
    }
    if (!tf) {
      this.setState({ smsSentModalOpen: false, beforeSendPopupOpen: false, purchaseModal: false });
    }
  };

  showPopup = (popup) => {
    this.setState({ [popup]: true });
    if (popup === 'exitPopupOpen') {
      this.setState({ smsComposeModalOpen: false });
    }
    if (popup === 'billingPopupOpen') {
      this.handleOpen(false);
      setTimeout(() => {
        this.handleOpen(true);
      }, 3000);
    }
    this.handleOpen(true);
  };

  closePopup = (popup) => {
    this.setState({ [popup]: false });
    if (popup !== 'exitPopupOpen') {
      this.handleOpen(false);
    }
    if (popup === 'billingPopupOpen' || popup === 'smsSentModalOpen') {
      this.props.setSmsMessage('', 0);
      if (this.props.showParentSmsPopup) {
        // we need to tell parent to close the sms popup
        this.props.showParentSmsPopup(false);
      }
    }
  };

  closePopupExit = () => {
    this.setState({ exitPopupOpen: false });
  };

  openPurchaseModal = () => {
    this.setState({ purchaseModal: true, smsSentModalOpen: false, beforeSendPopupOpen: false });
  };

  doSend = () => {
    this.sendSms();
  };

  render() {
    const {
      has_billing,
      sending_allowed,
      isOpen,
      permission,
      salonOnlineBooking,
      ncobTinyUrl,
      messageSent,
      procedure,
      duplicated,
      bucketType,
      bookingID,
      numOfMessages,
      clientName,
      expected_count,
      consultation_link,
      sms_credits_available,
      optoutNote,
      history,
      smsMessage,
      clientId,
      getUniqClients,
      numClientsToBeSentOptout,
      errorMessage,
      isFetching,
      purchaseSmsBundle,
      salonId,
      hideElement,
      customTitle,
      t,
    } = this.props;

    // sendSmsFrom => Check where sms is sent from.
    // Whether from booking card and feed or from marketing clients
    // then hide some text, checkbox for agree and duplicate button NEXT

    const sendSmsFrom = (procedure && procedure.appointment && procedure.appointment.id) || bookingID;
    const showHideElmClass = hideElement ? 'hidden' : sendSmsFrom ? 'sms-from-calendar hidden' : 'sms-from-marketing';

    const title = clientName
      ? customTitle
        ? t('scheduler.smsButton.sendMessage', { clientName })
        : t('scheduler.smsButton.replyTo', { clientName })
      : t('scheduler.smsButton.composeMessage');

    const popupContentBilling = t('scheduler.smsButton.noBillingDetails');
    const popupContentExit = t('scheduler.smsButton.exitMessage');

    const recipients = procedure?.appointment?.client ? [procedure?.appointment?.client?.id] : clientId;
    const appointmentId = bookingID ? bookingID : procedure?.appointment?.id ? procedure?.appointment?.id : void 1;

    return (
      <div data-bem="SmsButtonNew">
        <ReactModal
          isOpen={this.state.isOpen || (isOpen && this.state.smsComposeModalOpen)}
          closeTimeoutMS={0}
          ariaHideApp
          shouldCloseOnOverlayClick
          role="dialog"
          style={{ overlay: { zIndex: 500 } }}
          className={{
            base: 'dialog-container-marketing dark-class',
            afterOpen: 'dialog-container',
            beforeClose: 'dialog-container',
          }}
        >
          {this.state.billingPopupOpen && (
            <PopupWith2Buttons
              showPopup={this.showPopup}
              closePopup={this.closePopup}
              gotoBilling={this.gotoBilling}
              popupContent={popupContentBilling}
              billing
              finalAgreeToSend={false}
              fromAppointment
              handleOpen={this.handleOpen}
              isReceptionist={this.props.isReceptionist}
            />
          )}
          {this.state.beforeSendPopupOpen && (
            <PopupWith2Buttons
              isFetching={isFetching}
              messageSent={messageSent}
              showPopup={this.showPopup}
              closePopup={this.closePopup}
              doSend={this.doSend}
              popupContent={this.getPopupConentBeforeSend()}
              numOfMessages={numOfMessages}
              beforeSend
              sending_allowed={sending_allowed}
              setFinalAgreeToSend={this.setFinalAgreeToSend}
              finalAgreeToSend={this.state.finalAgreeToSend}
              uniqNote={this.uniqNoteConentBeforeSend()} // {uniqNote}
              optoutNote={optoutNote}
              duplicated={duplicated}
              numClientsToBeSentOptout={numClientsToBeSentOptout}
              fromAppointment={bucketType === 'appointment'}
              handleOpen={this.handleOpen}
              openPurchaseModal={this.openPurchaseModal}
              sendSMSVisibility={this.state.unique_recipients_count === 0 ? 'hidden' : ' '}
            />
          )}
          {this.state.smsComposeModalOpen && (
            <SmsComposeAndSend
              title={title}
              ButtonText="NEXT"
              onlineBooking={salonOnlineBooking}
              salonId={salonId}
              history={history}
              closePopup={this.closePopup}
              showPopup={this.showPopup}
              composeSMS
              setSmsMessage={this.setSmsMessage}
              smsMessage={smsMessage}
              messageSent={messageSent}
              getUniqClients={getUniqClients}
              currClientList={recipients}
              bucketType={bucketType}
              handleOpen={this.handleOpen}
              appointmentId={appointmentId}
              ncobTinyUrl={ncobTinyUrl}
              has_billing={has_billing}
              isModalAction={false}
              consultation_link={consultation_link}
              purchaseModal={this.state.purchaseModal}
              showHideElmClass={showHideElmClass}
            />
          )}
          {this.state.exitPopupOpen && (
            <div className="click-overlay">
              <PopupWith2Buttons
                closePopup={this.closePopupExit}
                showPopup={this.showPopup}
                popupContent={popupContentExit}
                exit
                fromAppointment
                handleOpen={this.handleOpen}
              />
            </div>
          )}
          {this.state.smsSentModalOpen && (
            <SmsSentDialog
              closePopup={this.closePopup}
              smsSent
              fromAppointment
              handleOpen={this.handleOpen}
              sms_credits_available={sms_credits_available}
              backToCalendar={() => this.handleOpen(false, 'success')}
              getMoreCredit={this.openPurchaseModal}
            />
          )}
          {/* flow 2 salon does not have enough SMS credits */}
          {/* change this to true salonNotSmsCreditPopup to see new modals */}
          {this.state.salonNotSmsCreditPopup && (
            <NotSmsCreditDialog
              history={history}
              isModalAction
              sms_credits_available={sms_credits_available}
              openPurchaseModal={this.openPurchaseModal}
              expected_count={expected_count}
              numClientsToBeSentOptout={numClientsToBeSentOptout}
            />
          )}
          {this.state.purchaseModal && (
            <PurchaseSmsCreditDialog
              showPopup={this.showPopup}
              closePopup={this.closePopup}
              purchaseSmsBundle={purchaseSmsBundle}
              salonId={salonId}
              isFetching={isFetching}
              sms_credits_available={sms_credits_available}
              errorMessage={errorMessage}
              gotoBilling={this.gotoBilling}
              handleOpen={this.handleOpen}
              permission={permission}
              variantButton="normal"
            />
          )}
        </ReactModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  salonId: state.currentSalon.id,
  salonName: state.currentSalon.name,
  has_billing: state.currentSalon.has_billing,
  permission: selectEffectiveUserRole(state),
  isReceptionist: isEffectiveReceptionist(state),
  pricePerSMS: state.currentSalon.price_per_sms,
  numOfMessages: state.clientCommunications.numOfMessages,
  smsMessage: state.clientCommunications.smsMessage,
  errorMessage: state.clientCommunications.errorMessage,
  messageSent: state.clientCommunications.messageSent,
  isFetching: state.clientCommunications.isFetching,
  ncobTinyUrl: state.settings.onlineBooking.settingsData.ncob_tiny_url,
  online_booking: state.currentSalon.online_booking,
  salonOnlineBooking: state.settings.onlineBooking.settingsData.online_booking,
  consultation_link: state.currentSalon.consultation_link,
  unique_recipients_count: state.clientCommunications.unique_recipients_count,
  phone: state.currentSalon.phone,
  displayStylists: state.scheduler.displayStylists,
  sending_allowed: state.clientCommunications.sending_allowed,
  sms_credits_available: state.clientCommunications.sms_credits_available,
  expected_count: state.clientCommunications.expected_count,
  clientHasNoPhone: state.clientCommunications.clientHasNoPhone,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      trackEvent,
      setSmsMessage,
      sendMarketingSMS,
      setMessageSent,
      getUniqClients,
      getSalonOnlineSettings,
      purchaseSmsBundle,
    },
    dispatch,
  );

// this extra export is needed for tests that provide their own mock for connect()
export { SmsButtonNew as SmsButtonNew4Test };

const SmsButtonNewHoc = withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SmsButtonNew)));

export default SmsButtonNewHoc;
